import { VariantMenuItem } from '@/models';

export function hasMaxContents(variant: VariantMenuItem): boolean {
  return variant.maxContents != -1;
}